import { Box, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { keyframes } from '@mui/system';
import { isMobile } from 'react-device-detect';

// Keyframe animation
const cloudyFadeOutLeft = keyframes`
  0% {
    opacity: 1;
    filter: blur(0);
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    filter: blur(10px);
  }
`;

export const WelcomeVideoWrapper = styled(Box)({
  margin: '0 auto',
  position: 'relative',
  minHeight: '450px',
  width: '100%',
});

export const WelcomeVideo = styled('video')({
  cursor: 'pointer',
  aspectRatio: '9/16',
  width: '100%',
});

export const Banner = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '6px',
  left: isMobile ? '8px' : '50%',
  transform: isMobile ? '0' : 'translateX(-50%)',
  zIndex: 10000,
  width: '95.5vw',
  maxWidth: '515px',
  background: theme.palette.common.white,
  color: '#2D11AD',
  border: `1.5px solid #2D11AD`,
  borderRadius: '9px',
  height: '16vw',
  maxHeight: '86px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

export const BannerTitle = styled(Typography)({
  fontFamily: 'Open Sans',
  fontSize: 'clamp(18px,  5vw, 27px)',
  fontWeight: '400',
  lineHeight: '20px',
  textAlign: 'center',
  marginBottom: isMobile ? '0' : '6px',
});

export const BtnWrapper = styled(Box)({
  position: 'absolute',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0 20px 0 12px',
  height: '58px',
  bottom: '60px',
  width: '100%',
});

export const BannerText = styled(Typography)({
  color: 'var(--lightBlack)',
  fontFamily: 'Open Sans',
  fontSize: 'clamp(14px,  3.9vw, 21px)',
  fontWeight: '400',
  lineHeight: '20px',
  textAlign: 'center',
});

export const PlayIcon = styled(Box)({
  position: 'absolute',
  width: '54px',
  height: '54px',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 100000,
});

export const MuteIcon = styled(IconButton)({
  '&:hover': {
    opacity: '0.9',
  },
  width: '54px',
  height: '54px',
  zIndex: 100001,
});

export const SkipIcon = styled(IconButton)({
  zIndex: 100001,
  '& svg': {
    fill: 'white',
  },
  '&:hover': {
    backgroundColor: 'transparent',
  },
});

export const SkipText = styled(Typography)({
  color: 'white',
  fontFamily: 'Open Sans',
  fontSize: '40px',
  fontWeight: 600,
  lineHeight: '20px',
  textAlign: 'center',
});

export const FadeOutBox = styled(Box)<{ $fadeOut?: boolean }>(({ $fadeOut }) => ({
  ...($fadeOut && {
    animation: `${cloudyFadeOutLeft} 1.5s ease-out forwards`,
    opacity: 1,
  }),
}));
